import { Auth } from 'aws-amplify';

export default async () => {
    const session = await Auth.currentSession();
    const accessToken = await session.getRefreshToken();
    return await accessToken.getToken();
}